export interface BreadcrumbItem {
  id: string;
  label: string;
  href: string;
  isVisible: boolean;
  isActive?: boolean;
}

export const BREADCRUMB_CONFIG: BreadcrumbItem[] = [
  {
    id: 'initials',
    label: 'Iniciales',
    href: '/photo-sections/INTERIOR',
    isVisible: true,
  },
  {
    id: 'diagnostico',
    label: 'Diagnóstico',
    href: '/photo-sections/DIAGNOSTICO',
    isVisible: false, // Oculto según criterios de aceptación
  },
  {
    id: 'externas',
    label: 'Externas',
    href: '/photo-sections/EXTERIOR',
    isVisible: true,
  },
];

export const getBreadcrumbConfig = (currentPath?: string): BreadcrumbItem[] => {
  const path = currentPath || window.location.pathname;

  return BREADCRUMB_CONFIG.map((item) => ({
    ...item,
    isActive: determineActiveState(item, path),
  }));
};

const determineActiveState = (item: BreadcrumbItem, path: string): boolean => {
  switch (item.id) {
    case 'iniciales':
      return path.includes('OTHERS');
    case 'externas':
      return path.includes('EXTERIOR');
    default:
      return false;
  }
};
